import CategorizedDocuments from "./categorized-documents";

export default CategorizedDocuments;
